<template>
  <div class="container">
    <div class="head header">
      <img src="@/assets/back.png" style="margin: 10px" alt="返回" width="21" height="21" @click="go">
      <div>我的收益</div>
      <div style="margin-right: 10px;color: #FE003B" @click="withdraw">提现</div>
    </div>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" style="font-size: 0.7rem">
          <div @click="handleTag(0)" :class="activeTag==0 ? 'active':''">自购收益({{userIncome.selfTotal}}元)</div>
        </div>
        <div class="item" style="font-size: 0.7rem">
          <div @click="handleTag(1)" :class="activeTag==1 ? 'active':''">推荐收益({{userIncome.shareTotal}}元)</div>
        </div>
        <div class="item" style="font-size: 0.7rem">
          <div @click="handleTag(2)" :class="activeTag==2 ? 'active':''">收益消费明细</div>
        </div>
      </div>
    </div>


    <!--自购收益-->
    <template v-if="activeTag==0">
      <div class="tabs" style="background: #F6F6F6">
        <div class="tab" style="justify-content: space-between;">
          <div class="item" v-for="(item,index) in twoTabList" :key="index">
            <div @click="twoHandleTag(index)" :class="twoActiveTag==index ? 'active':''">{{item}}</div>
          </div>
        </div>
      </div>
      <div class="recharge" v-for="i in autoList" :key="i.id">
        <div class="rechargeme">
          <div class="title">{{i.remark}}</div>
          <div class="status">{{i.rebateType|checkRebateType(i.rebateType)}}</div>
        </div>
        <div class="eaprice">+ {{i.money}}</div>
        <div class="redate">{{i.createTime}}</div>
      </div>
      <empty v-if="autoList.length==0"/>
    </template>

    <!--推荐收益-->
    <template  v-if="activeTag==1">
      <div class="tabs" style="background: #F6F6F6">
        <div class="tab" style="justify-content: space-between;">
          <div class="item" v-for="(item,index) in twoTabList" :key="index">
            <div @click="twoHandleTag(index)" :class="twoActiveTag==index ? 'active':''">{{item}}</div>
          </div>
        </div>
      </div>
      <div class="recharge" v-for="i in autoList" :key="i.id">
        <div class="rechargeme">
          <div class="title">{{i.remark}}</div>
          <div class="status">{{i.rebateType|checkRebateType(i.rebateType)}}</div>
        </div>
        <div class="eaprice">+ {{i.money}}</div>
        <div class="redate">{{i.createTime}}</div>
      </div>
      <empty v-if="autoList.length==0"/>
    </template>

    <!--收益消费明细-->
    <template  v-if="activeTag==2">
      <div class="recharge" v-for="i in conList" :key="i.id">
        <div class="rechargeme">
          <div class="title">{{i.remark}}</div>
        </div>
        <div class="eaprice">-{{i.money}}</div>
        <div class="redate">{{i.createTime}}</div>
      </div>
      <empty v-if="conList.length==0"/>
    </template>

  </div>

</template>

<script>
import { queryShopIncomeList,queryShopChargeList,totalIncome } from '@/api/mine/earning.js'
import {getCurtUser} from '@/api/login/index.js'
export default {
  name: 'Earnings',
  data() {
    return {
      show: true,
      activeTag: 0,
      twoActiveTag: 0,
      tabList: ['自购收益', '推荐收益','收益消费明细'],
      twoTabList: ['全部', '待返利', '返利成功', '返利失败'],
      autoList: [],
      conList: [],
      userInfo: {},
      userIncome: {}
    }
  },
  created() {
    this._getUser()
    this._queryShopIncomeList()
    this._totalIncome()
  },
  filters:{
    checkRebateType(val){
      let name = ''
      if(val == 1){
        name = '待返利'
      }else if( val == 2 ){
        name = '返利成功'
      }else{
        name = '返利失败'
      }
    }
  },
  methods: {
    _totalIncome(){
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      totalIncome({uid: user.id}).then(res => {
        if (res.success) {
          this.userIncome = res.data
        }
      })
    },
    _getUser(){
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      if (!user) {
        this.$toast.fail('请登陆')
        return;
      }
      getCurtUser({id: user.id}).then(res => {
        if (res.success) {
          this.userInfo = res.data
        }
      })
    },
    _queryShopIncomeList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      if (!user) {
        this.$toast.fail('请登陆')
        return;
      }
      const params = {
        uid: user.id,
        type: this.activeTag,
        rebateType: this.twoActiveTag
      }
      queryShopIncomeList(params).then((res) => {
        if (res.success) {
          this.autoList = res.data
        }
      })
    },
    _queryShopChargeList(){
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      if (!user) {
        this.$toast.fail('请登陆')
        return;
      }
      const params = {
        uid: user.id,
        type: 3
      }
      queryShopChargeList(params).then((res) => {
        if (res.success) {
          this.conList = res.data
        }
      })
    },
    handleTag(index) {
      this.activeTag = index
      if (index==2){
        this._queryShopChargeList()
      } else{
        this._queryShopIncomeList()
      }
    },
    twoHandleTag(index) {
      this.twoActiveTag = index
      this._queryShopIncomeList()
    },
    go() {
      this.$router.go(-1)
    },
    withdraw() {
      this.$router.push('/withdraw')
    }
  }
}
</script>
<style lang="less" scoped>
  .container{
    padding-top: 50px;
    .head{
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      min-height:44px;
      height: auto;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        .item{
          font-size:14px;
          font-weight:500;
          /*height:22px;*/
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            //font-size:16px;
            //font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .recharge{
      padding: 12px;
      border-bottom: 2px solid #EDEDED;
      .rechargeme{
        display: flex;
        justify-content: space-between;
        .title{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(102,102,102,1);
          opacity:1;
        }
        .status{
          font-size:12px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:17px;
          color:rgba(254,0,59,1);
          opacity:1;
        }
      }
      .eaprice{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(254,0,59,1);
        opacity:1;
        margin-top: 5px;
        text-align: right;
        margin-right: 12px;
      }
      .redate{
        width:100%;
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(136,137,136,1);
        opacity:1;
        margin-top: 6px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/mine/earnings.vue